var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Done from '@mui/icons-material/Done';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';

var useStyles = makeStyles(function () {
  return {
    visibility: {
      visibility: 'hidden'
    },
    input: {
      '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&[type=number]': {
        '-moz-appearance': 'textfield'
      }
    }
  };
});

var LefttIcon = function LefttIcon(_ref) {
  var Icon = _ref.Icon;
  return React.createElement(Icon, null);
};

LefttIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  Icon: PropTypes.object
} : {};

var RightIcon = function RightIcon(_ref2) {
  var onSubmit = _ref2.onSubmit,
      _ref2$Icon = _ref2.Icon,
      Icon = _ref2$Icon === undefined ? Done : _ref2$Icon;
  return React.createElement(
    IconButton,
    { color: 'primary', onClick: function onClick() {
        return onSubmit();
      }, size: 'large' },
    React.createElement(Icon, null)
  );
};

RightIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  Icon: PropTypes.object,
  onSubmit: PropTypes.func,
  classes: PropTypes.object
} : {};

var MyInput = function MyInput(_ref3) {
  var id = _ref3.id,
      value = _ref3.value,
      onSubmit = _ref3.onSubmit,
      onReset = _ref3.onReset,
      resetLabel = _ref3.resetLabel,
      placeholder = _ref3.placeholder,
      props = _objectWithoutProperties(_ref3, ['id', 'value', 'onSubmit', 'onReset', 'resetLabel', 'placeholder']);

  var classes = useStyles();

  var _useState = useState(value || ''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  useEffect(function () {
    setInputValue(value);
  }, [value]);

  var resetId = 'reset-' + id;

  var handleBlur = function handleBlur(event) {
    if (R.is(Function, onSubmit) && inputValue !== value) {
      onSubmit(event.target.value);
    }
  };

  var handleReset = function handleReset() {
    if (R.is(Function, onReset)) {
      onReset();
    } else {
      setInputValue(value);
    }
  };

  var onEnterLabel = function onEnterLabel(event) {
    if (event.key === 'Enter') {
      if (R.is(Function, onSubmit)) {
        onSubmit(event.target.value);
      }
    }
  };

  var handleChange = function handleChange(event) {
    setInputValue(event.target.value);
  };

  var endAdornment = R.is(Function, onReset) || inputValue !== value ? React.createElement(
    InputAdornment,
    { position: 'end' },
    React.createElement(
      IconButton,
      {
        id: resetId,
        'aria-label': resetLabel,
        onKeyPress: onEnterLabel,
        onClick: handleReset,
        size: 'large'
      },
      React.createElement(RotateLeftIcon, { fontSize: 'small' })
    )
  ) : null;

  return React.createElement(TextField, _extends({
    inputProps: {
      className: classes.input
    },
    onBlur: handleBlur,
    margin: 'dense',
    size: 'small',
    variant: 'outlined',
    onKeyPress: onEnterLabel,
    onChange: handleChange,
    id: id,
    value: inputValue,
    InputProps: {
      endAdornment: endAdornment
    },
    placeholder: R.is(Number)(placeholder) ? R.toString(placeholder) : placeholder
  }, R.omit(['isActive'])(props)));
};

export { MyInput };
MyInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  resetLabel: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};

export default MyInput;